import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../components/ui/Section';
export function PrivacyPage() {
  const sections = [{
    number: '1',
    title: 'Overview',
    content: <p data-id="element-336">
          Belo Digital is committed to protecting personal data and privacy.
          This policy explains how we collect, use, and safeguard information.
        </p>
  }, {
    number: '2',
    title: 'Information We Collect',
    content: <>
          <p className="mb-6" data-id="element-337">We may collect:</p>
          <div className="space-y-6" data-id="element-338">
            <div data-id="element-339">
              <h4 className="font-semibold text-[#0C0C0C] mb-3" data-id="element-340">
                a) Personal Information
              </h4>
              <ul className="space-y-2" data-id="element-341">
                {['Names', 'Email addresses', 'Phone numbers', 'Company details', 'Job or professional information'].map(item => <li key={item} className="flex items-start" data-id="element-342">
                    <span className="w-2 h-2 rounded-full bg-[#00316B] mt-2 mr-3 shrink-0" data-id="element-343" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div data-id="element-344">
              <h4 className="font-semibold text-[#0C0C0C] mb-3" data-id="element-345">
                b) Technical Information
              </h4>
              <ul className="space-y-2" data-id="element-346">
                {['IP addresses', 'Browser/device data', 'Usage analytics'].map(item => <li key={item} className="flex items-start" data-id="element-347">
                      <span className="w-2 h-2 rounded-full bg-[#00316B] mt-2 mr-3 shrink-0" data-id="element-348" />
                      {item}
                    </li>)}
              </ul>
            </div>
            <div data-id="element-349">
              <h4 className="font-semibold text-[#0C0C0C] mb-3" data-id="element-350">
                c) Client & Business Data
              </h4>
              <p data-id="element-351">Where relevant to services delivered under contract.</p>
            </div>
          </div>
        </>
  }, {
    number: '3',
    title: 'How We Use Information',
    content: <>
          <p className="mb-4" data-id="element-352">We use data to:</p>
          <ul className="space-y-2" data-id="element-353">
            {['Deliver and improve services', 'Communicate with clients & partners', 'Provide technical support', 'Meet legal or regulatory obligations', 'Enhance security and performance'].map(item => <li key={item} className="flex items-start" data-id="element-354">
                <span className="w-2 h-2 rounded-full bg-[#00316B] mt-2 mr-3 shrink-0" data-id="element-355" />
                {item}
              </li>)}
          </ul>
        </>
  }, {
    number: '4',
    title: 'Data Protection & Security',
    content: <>
          <p className="mb-4" data-id="element-356">
            We implement reasonable technical and organizational safeguards to
            protect data against:
          </p>
          <ul className="space-y-2" data-id="element-357">
            {['Unauthorized access', 'Loss or misuse', 'Alteration or disclosure'].map(item => <li key={item} className="flex items-start" data-id="element-358">
                <span className="w-2 h-2 rounded-full bg-[#00316B] mt-2 mr-3 shrink-0" data-id="element-359" />
                {item}
              </li>)}
          </ul>
        </>
  }, {
    number: '5',
    title: 'Data Sharing',
    content: <>
          <p className="mb-4" data-id="element-360">
            We do not sell personal data. Information may only be shared:
          </p>
          <ul className="space-y-2" data-id="element-361">
            {['With authorized service providers', 'Where legally required', 'Under contractual obligations'].map(item => <li key={item} className="flex items-start" data-id="element-362">
                <span className="w-2 h-2 rounded-full bg-[#00316B] mt-2 mr-3 shrink-0" data-id="element-363" />
                {item}
              </li>)}
          </ul>
        </>
  }, {
    number: '6',
    title: 'Data Retention',
    content: <p data-id="element-364">
          We retain data only as long as necessary for legitimate business,
          contractual, or legal purposes.
        </p>
  }, {
    number: '7',
    title: 'User Rights',
    content: <>
          <p className="mb-4" data-id="element-365">
            Subject to applicable law, individuals may request:
          </p>
          <ul className="space-y-2" data-id="element-366">
            {['Access to their data', 'Correction of inaccuracies', 'Deletion where appropriate', 'Withdrawal of consent (where applicable)'].map(item => <li key={item} className="flex items-start" data-id="element-367">
                <span className="w-2 h-2 rounded-full bg-[#00316B] mt-2 mr-3 shrink-0" data-id="element-368" />
                {item}
              </li>)}
          </ul>
        </>
  }, {
    number: '8',
    title: 'Cookies & Tracking',
    content: <p data-id="element-369">
          Our website may use cookies or analytics tools to improve user
          experience and performance.
        </p>
  }, {
    number: '9',
    title: 'Third-Party Links',
    content: <p data-id="element-370">
          Our website may contain external links. We are not responsible for
          third-party privacy practices.
        </p>
  }, {
    number: '10',
    title: 'Policy Updates',
    content: <p data-id="element-371">
          We may revise this Privacy Policy periodically. Updates will be
          reflected with a new effective date.
        </p>
  }, {
    number: '11',
    title: 'Contact Information',
    content: <div className="space-y-2" data-id="element-372">
          <p data-id="element-373">For privacy-related inquiries:</p>
          <p className="font-semibold text-[#0C0C0C]" data-id="element-374">Belo Digital</p>
          <p data-id="element-375">
            Email:{' '}
            <a href="mailto:biz@belo.co.ke" className="text-[#00316B] hover:text-[#FF6600] transition-colors" data-id="element-376">
              biz@belo.co.ke
            </a>
          </p>
          <p data-id="element-377">
            Phone:{' '}
            <a href="tel:+254735977519" className="text-[#00316B] hover:text-[#FF6600] transition-colors" data-id="element-378">
              0735 977 519
            </a>
          </p>
        </div>
  }];
  return <main className="pt-24" data-id="element-379">
      <Section background="default" data-id="element-380">
        <div className="max-w-4xl" data-id="element-381">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-sm font-semibold text-[#00316B] uppercase tracking-wider mb-4" data-id="element-382">
            Legal
          </motion.p>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.05
        }} className="text-4xl md:text-5xl font-bold font-heading text-[#0C0C0C] mb-4 leading-tight" data-id="element-383">
            Privacy Policy
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-gray-500 text-sm" data-id="element-384">
            Last updated:{' '}
            {new Date().toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          })}
          </motion.p>
        </div>
      </Section>

      <Section background="white" data-id="element-385">
        <div className="max-w-3xl mx-auto" data-id="element-386">
          <div className="space-y-12" data-id="element-387">
            {sections.map((section, index) => <motion.div key={section.number} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.04
          }} className="border-b border-gray-100 pb-12 last:border-0" data-id="element-388">
                <div className="flex items-start gap-4 mb-4" data-id="element-389">
                  <span className="text-xs font-bold text-[#00316B] bg-[#00316B]/10 px-2 py-1 rounded mt-1 shrink-0" data-id="element-390">
                    {section.number.padStart(2, '0')}
                  </span>
                  <h2 className="text-xl font-bold font-heading text-[#0C0C0C]" data-id="element-391">
                    {section.title}
                  </h2>
                </div>
                <div className="ml-10 text-gray-600 leading-relaxed text-[15px]" data-id="element-392">
                  {section.content}
                </div>
              </motion.div>)}
          </div>
        </div>
      </Section>
    </main>;
}